import {ISelectOption} from "../components/forms/select-component";

export const cesModerationTypeList: ISelectOption[] = [{ id: 'TM', name: 'Tous sauf Trusted' }];
